import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const AppearanceSection = () => {
  const [theme, setTheme] = useState('system');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'system';
    setTheme(savedTheme);
    applyTheme(savedTheme);
  }, []);

  const applyTheme = (selectedTheme) => {
    const root = document.documentElement;
    
    if (selectedTheme === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
      root.classList?.toggle('dark', prefersDark);
    } else if (selectedTheme === 'dark') {
      root.classList?.add('dark');
    } else {
      root.classList?.remove('dark');
    }
  };

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    applyTheme(newTheme);
    setSuccess('Theme updated successfully');
    setTimeout(() => setSuccess(''), 2000);
  };

  const themeOptions = [
    {
      id: 'system',
      label: 'System',
      description: 'Automatically match your device settings',
      icon: 'Monitor'
    },
    {
      id: 'light',
      label: 'Light',
      description: 'Light theme for bright environments',
      icon: 'Sun'
    },
    {
      id: 'dark',
      label: 'Dark',
      description: 'Dark theme for low-light environments',
      icon: 'Moon'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-20 md:p-24">
      <div className="flex items-center gap-12 mb-20">
        <Icon name="Palette" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-heading font-semibold text-card-foreground">Appearance</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-24">
        Customize how Rovyn Budget looks on your device
      </p>

      {success && (
        <div className="mb-20 p-16 bg-success/10 border border-success/20 rounded-lg flex items-start gap-12">
          <Icon name="CheckCircle" size={20} color="var(--color-success)" />
          <p className="text-sm text-success flex-1">{success}</p>
        </div>
      )}

      <div className="space-y-12">
        <h3 className="text-sm font-caption font-semibold text-foreground mb-16">Theme</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {themeOptions?.map((option) => (
            <button
              key={option?.id}
              onClick={() => handleThemeChange(option?.id)}
              className={`
                p-20 rounded-lg border-2 transition-smooth text-left
                ${theme === option?.id
                  ? 'border-primary bg-primary/5' :'border-border bg-background hover:border-primary/50'
                }
              `}
            >
              <div className="flex items-center gap-12 mb-12">
                <div className={`
                  flex items-center justify-center w-10 h-10 rounded-lg
                  ${theme === option?.id ? 'bg-primary/10' : 'bg-muted'}
                `}>
                  <Icon
                    name={option?.icon}
                    size={20}
                    color={theme === option?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-8">
                    <span className="text-sm font-caption font-semibold text-foreground">
                      {option?.label}
                    </span>
                    {theme === option?.id && (
                      <Icon name="Check" size={16} color="var(--color-primary)" />
                    )}
                  </div>
                </div>
              </div>
              <p className="text-xs text-muted-foreground">{option?.description}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppearanceSection;